<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>家园留言</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>基本配置</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="留言开关">
                  <el-select v-model="basic.status" placeholder="请选择">
                    <el-option
                      v-for="item in optionsArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="等级范围">
                  <el-input v-model.number="basic.minLevel" placeholder="最低等级" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="basic.maxLevel" placeholder="最高等级" />
                </el-form-item>
                <el-form-item label="每次发送间隔(秒)">
                  <el-input v-model.number="basic.interval" placeholder="每次发送间隔(秒)" />
                </el-form-item>
                <el-form-item label="每个用户发送次数(天)">
                  <el-input v-model.number="basic.sendNum" placeholder="每天发送次数" />
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
        <el-button class="mtop" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'RobotSlot',
  data() {
    return {
      key: 'ROBOT_FRIEND_CONFIG:MESSAGE',
      optionsArr: [{ label: '开', value: 1 }, { label: '关', value: 0 }],
      basic: {
        status: 0,
        interval: 60,
        sendNum: 5,
        minLevel: 1,
        maxLevel: 100
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
